export const checkPermissions = ({
  allowedPermissions,
  userPermissions,
}: {
  allowedPermissions: string[];
  userPermissions: string[];
}): boolean => {
  if (allowedPermissions.length === 0) return true;

  return allowedPermissions.some((allowedPermission) =>
    userPermissions.includes(allowedPermission)
  );
};
